;(function($, moment) {
  'use strict';

  var KEY_DAY = 'day',
    KEY_MONTH = 'month',
    KEY_YEAR = 'year',
    DEFAULT_FORMAT = 'YYYY-MM-DD',
    MAX_DAYS_IN_MONTH = 31,
    DEFAULT_DATE_OF_MONTH = 1,
    pluginName = 'uitk_dob_select',
    EMPTY_MONTH_VALUE = I18n.t('date_dropdown_default_month'),
    EMPTY_DAY_VALUE = I18n.t('date_dropdown_default_day'),
    EMPTY_YEAR_VALUE = I18n.t('date_dropdown_default_year');

  /* Constructor */
  var DOBType = function(elem) {
    // initValue is the initial value the component will be initialized with. YYYY-MM-DD (2013-04-01)
    var initValue, minYears, maxYears;

    minYears = elem.data('minYears') || 0;
    maxYears = elem.data('maxYears') || 0;
    initValue = elem.attr('data-value');

    this._isValid = true;
    // $elem is the dob DIV which contains all 3 dropdown elements
    this.$elem = elem;

    //dob-ctl is the hidden text field to store the value of DOB
    this.$dob = this.$elem.parent().find('[data-control="dob-ctl"]');

    // prepare data for date component
    this._prepareData(initValue, minYears, maxYears);

    //Prepare all three drop downs
    this._day = this.$elem.find('[data-dropdown-context="day"]').dropdownType(this._getDropDownItems(KEY_DAY));
    this._month = this.$elem.find('[data-dropdown-context="month"]').dropdownType(this._getDropDownItems(KEY_MONTH));
    this._year = this.$elem.find('[data-dropdown-context="year"]').dropdownType(this._getDropDownItems(KEY_YEAR));

    this._setupEvents();
    this._evaluate();
  };

  // Prototype
  DOBType.prototype = {
    constructor: DOBType,

    /**
     * Set up Event handlers to handle changes done on any of the three dropdowns
     * @private
     */
    _setupEvents: function() {
      ;(function(_this) {
        uitk.subscribe('selection.changed.event', function(evtName, args) {
          var ddType = args.context;
          var selectedValue = args.value;

          if (ddType == KEY_YEAR) {
            _this._onYearChange(selectedValue);
          }
          if (ddType == KEY_MONTH) {
            _this._onMonthChange(selectedValue);
          }
          if (ddType == KEY_DAY) {
            _this._onDayChange(selectedValue);
          }
        });
      })(this);
    },

    /**
     * Prepare initial data for DOB component in form of uitk.data.dob[day, month, year]
     * @param _maxYears specifies max years from which this component should be initialized
     * @param _initValue Any date with which this component should be initialized. (YYYY-MM-DD)
     * @private
     */
    _prepareData: function(initValue, minYears, maxYears) {
      var now = moment(),
        startYear = now.year() - minYears,
        endYear = now.year() + maxYears,
        currentYear = now.year(),
        initDay = EMPTY_DAY_VALUE,
        initDate,
        initYear = EMPTY_YEAR_VALUE,
        years = [],
        initMonthIndex,
        year = startYear;

      // Check if dob data is already present in uitk else prepare
      if (!uitk.data) {
        uitk.data = {};
      }
      uitk.data.dob = {};

      // calculate years
      if (initValue) {
        initDate = moment(initValue, DEFAULT_FORMAT);
        initDay = initDate.date();
        initMonthIndex = initDate.month() + 1;
        initYear = initDate.year();
      }
      years.push({ selected: initYear === EMPTY_YEAR_VALUE, item: EMPTY_YEAR_VALUE });
      while (year <= endYear) {
        years.push({ selected: initDate && initDate.year() == year, item: year });
        year++;
      }

      this._setDropdownItems(KEY_YEAR, years);
      this._setDropdownItems(KEY_MONTH, this._calculateMonths(initMonthIndex));
      this._setDropdownItems(KEY_DAY, this._calculateDays(initYear, initMonthIndex, initDay));
    },

    /**
     * Updates the items for a specific type(D/Y/M) of dropdown in uitk.data.dob
     * @param type
     * @param items
     * @private
     */
    _setDropdownItems: function(type, items) {
      uitk.data.dob[type] = { items: items, type: type };
    },

    /**
     * Fetches data for date[type(D/M/Y)] from uitk.data.dob.
     * @param type
     * @returns {*}
     * @private
     */
    _getDropDownItems: function(type) {
      return uitk.data.dob[type];
    },

    /**
     * Prepare months array
     * @param defaultMonthIndex
     * @returns {Array}
     * @private
     */
    _calculateMonths: function(defaultMonthIndex) {
      var months = [];
      months.push({ selected: !defaultMonthIndex, item: EMPTY_MONTH_VALUE });
      if (!defaultMonthIndex) {
        defaultMonthIndex = 0;
      }
      moment.months().forEach(function(month, i) {
        months.push({ selected: defaultMonthIndex - 1 == i ? true : false, item: month });
      });

      return months;
    },

    /**
     * Calculate days for a specific Y, M and day group.
     * @param year
     * @param month
     * @param selectedDate
     * @returns {Array}
     * @private
     */
    _calculateDays: function(year, month, selectedDate) {
      var daysInMonth = [],
        maxDays = MAX_DAYS_IN_MONTH,
        counter = 1;

      if (month && year) {
        var m = moment([year, month - 1, DEFAULT_DATE_OF_MONTH]);
        maxDays = m.daysInMonth();
      }
      daysInMonth.push({ selected: !selectedDate, item: EMPTY_DAY_VALUE });
      if (selectedDate > maxDays) {
        selectedDate = DEFAULT_DATE_OF_MONTH;
        this._day.setSelectedValue(DEFAULT_DATE_OF_MONTH);
        this._day.setSelectedIndex(DEFAULT_DATE_OF_MONTH);
      }

      while (counter <= maxDays) {
        daysInMonth.push({ selected: parseInt(selectedDate) === counter, item: counter });
        counter++;
      }
      return daysInMonth;
    },

    /**
     * Recalculates days on the change of an year
     * @param selectedYear
     * @private
     */
    _onYearChange: function(selectedYear) {
      var month = this._month.getSelectedIndex() > 0 ? this._month.getSelectedIndex() : undefined,
        year = selectedYear !== EMPTY_YEAR_VALUE ? selectedYear : undefined;
      // re-calculate days
      var days = this._calculateDays(year, month, this._day.getSelectedValue());

      this._setDropdownItems(KEY_DAY, days);
      this._day.updateValues(this._getDropDownItems(KEY_DAY));
      this._evaluate();
    },

    /**
     * Recalculates days on the change of an month
     * @param selectedMonth
     * @private
     */
    _onMonthChange: function(selectedMonth) {
      var month = this._month.getSelectedIndex() > 0 ? this._month.getSelectedIndex() : undefined,
        year = this._year.getSelectedValue() !== EMPTY_YEAR_VALUE ? this._year.getSelectedValue() : undefined;
      // re-calculate days
      var days = this._calculateDays(year, month, this._day.getSelectedValue());
      this._setDropdownItems(KEY_DAY, days);
      this._day.updateValues(this._getDropDownItems(KEY_DAY));
      this._evaluate();
    },

    /**
     *
     * @param selectedDay
     * @private
     */
    _onDayChange: function(selectedDay) {
      // No impact on any other dropdown so just re-evaluate
      this._evaluate();
    },

    /**
     * Re-evaluate the date and sets the value on hidden $dob field
     * @private
     */
    _evaluate: function() {
      var date;
      if (!this.isEmpty()) {
        date = new moment([
          this._year.getSelectedValue(),
          this._month.getSelectedIndex() - 1,
          this._day.getSelectedValue()
        ]);
        if (!date.isValid()) {
          this._isValid = false;
          this.$dob.val('INVALID_DATE');
        } else {
          this._isValid = true;
          this.$dob.val(date.format(DEFAULT_FORMAT));
          this.$elem.attr('data-value', date.format(DEFAULT_FORMAT));
        }
      } else {
        this.$dob.val('');
      }
    },

    isEmpty: function() {
      return (
        this._year.getSelectedValue() === EMPTY_YEAR_VALUE &&
        this._month.getSelectedIndex() === 0 &&
        this._day.getSelectedValue() === EMPTY_DAY_VALUE
      );
    },

    /**
     * Gets current value of date
     * @returns {*}
     */
    getCurrentValue: function() {
      return this.$dob.val();
    },

    /**
     * Checks whether the selected date is valid or not
     * @returns {boolean}
     */
    isValid: function() {
      return this._isValid;
    }
  };

  $.fn.dateType = function() {
    return new DOBType(this);
  };

  /* JQUERY PLUGIN DEFINITION */
  uitk.utils.initPlugin(pluginName, DOBType);

  var initDOB = function() {
    var $dob = $('[data-control="dob"]');
    if ($dob.length < 1) {
      return;
    }

    $.each($dob, function(idx, el) {
      $(el).dateType();
    });
  };

  $(document).ready(function() {
    initDOB();
  });

  // Expose initDOB function for dynamic client-side rendering.
  uitk.initDOB = initDOB;

  // Expose object so it can be tested more easily
  uitk.modules.DOB_multi_select = DOBType;
})(window.jQuery, moment);
